import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { pickBy } from 'lodash';

import { appliedFiltersSelector } from '@classCreation/selectors/sbatGroupBulkUpdateFilter';
import applyFiltersOnSbatGroup from '@classCreation/utils/applyFiltersOnSbatGroup';
import isValidSbatGroupFilter from '@classCreation/utils/isValidSbatGroupFilter';

export default function useFilteredSbatGroups(sbatGroups) {
  const appliedFilters = useSelector(appliedFiltersSelector);

  const filteredSbatGroups = useMemo(() => {
    const validFilters = pickBy(appliedFilters, isValidSbatGroupFilter);

    if (Object.keys(validFilters).length > 0) {
      return sbatGroups.filter((sbatGroup) =>
        applyFiltersOnSbatGroup({
          sbatGroup,
          filters: validFilters,
        })
      );
    } else {
      return sbatGroups;
    }
  }, [sbatGroups, appliedFilters]);

  return filteredSbatGroups;
}
